import { computed, inject, InjectionKey, provide, ref, Ref, watch } from "vue";
import {
  BrandContext,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";

export interface AnimationSync {
  listener: ($event?: undefined) => void;
  synced: Ref<boolean>;
}

/**
 * util hook to check when all button animations have been completed in an ad,
 * to enable the button animations to move onto the repeat together in sync
 */
export function useAnimationSync(testing: boolean): AnimationSync {
  const synced = ref(false);
  const called = ref(0);
  const interval = ref<any>();

  const branding = injectBrand() || ({} as BrandContext);

  // hack to reset the sync when the button animation change in console
  const buttons = computed(() =>
    branding.buttons.value
      ? JSON.stringify(
          Object.values(branding.buttons.value).map(b => b.animations)
        )
      : ""
  );
  watch(buttons, () => {
    synced.value = false;
    called.value = 0;
  });

  function listener() {
    called.value += 1;

    interval.value = setTimeout(() => {
      if (lastvalue === called.value) {
        synced.value = true;
        called.value = 0;
        clearInterval(interval.value);
      }
    }, 200);

    const lastvalue = called.value;
  }

  return {
    listener,
    synced
  };
}

const AnimationSynxInjectionKey: InjectionKey<AnimationSync> = Symbol(
  "animation-sync"
);

export function provideAnimationSync(testing = false) {
  provide(AnimationSynxInjectionKey, useAnimationSync(testing));
}

export function injectAnimationSync() {
  return inject(AnimationSynxInjectionKey, {
    synced: ref(false),
    listener: () => {}
  });
}
